import type { ReactQueryOptions } from 'utils/trpc';
import { trpc } from 'utils/trpc';

export const useUserUpdateActivity = (
  options?: ReactQueryOptions['user']['updateActivity'],
) => {
  return trpc.user.updateActivity.useMutation(options);
};
